import { useGetVeriffStatus } from '@/query/queries/user/useGetVeriffStatus';
import { VERIFF_CODES } from '@/helpers/constants';

export const useVeriffStatus = () => {
  const { data: veriffStatus } = useGetVeriffStatus();

  const code = veriffStatus?.code;

  return {
    ready: !!veriffStatus,
    veriffStatus,
    veriffCode: code,
    isDuplicationPassport: code === VERIFF_CODES.customPassportDuplication,
    isDuplicationAccount: code === VERIFF_CODES.customPersonalDuplication,
    isVeriffPassed: code === VERIFF_CODES.verified,
    isVeriffSubmitted: code === VERIFF_CODES.submitted,
    isVeriffApplyError: [
      VERIFF_CODES.notVerified,
      VERIFF_CODES.reSubmitRequest,
    ].includes(code),
    isVeriffApplyRequired: ![
      VERIFF_CODES.verified,
      VERIFF_CODES.submitted,
    ].includes(code),
  };
};
